document.addEventListener("DOMContentLoaded", () => {
  let formContainer = document.querySelector(
    "#AeGdDNzhCcVREdlAza__forms_inline_dMy3et"
  );

  let observer = new MutationObserver((mutationsList, observer) => {
    let form = document.querySelector("form-embed");

    if (form) {
      observer.disconnect();
      let shadow = form.shadowRoot;

      let sheet = new CSSStyleSheet();
      sheet.insertRule(`
        fieldset legend{
          font-size: 17px !important;
          font-weight: 800 !important;
          letter-spacing: 0.5px !important;
          padding: 15px 0px !important;
          margin: 0 !important;
          font-family: var(--heading-font) !important; 
        }
      `);
      sheet.insertRule(`
        section._formContainer_stahb_30._grid_stahb_148._noImage_stahb_161{
              max-width: 60% !important;
        }
      `);
      sheet.insertRule(`
        button._formSubmitButton_1ll8d_81{
          width: 50%;
          margin: 0 auto;
          background: #0b00b5;
          font-size: 20px;
          font-weight: 700;
          letter-spacing: 1.1px;
          font-family: "Roboto Condensed", sans-serif;
        }
      `);
      shadow.adoptedStyleSheets.push(sheet);
      formContainer.classList.add("loaded");
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
$(document).on("click", "#filter li", function () {
  var self = $(this);
  var handle = self.attr("data-handle");
  if (handle === "all") {
    $(".product-card").parent().removeClass("hidden", 1000);
  } else {
    $(".product-card").each(function () {
      var selfTag = $(this);
      var tag = selfTag.attr("data-tags");
      // Show or hide the product based on the active filters
      if (tag.includes(handle)) {
        selfTag.parent().removeClass("hidden", 1000);
      } else {
        selfTag.parent().addClass("hidden", 1000);
      }
    });
  }

  // Update the active class
  $("#filter li").removeClass("active");
  self.addClass("active");
});
$(document).ready(function () {
  let trgEl = $(".multicolumn-wrapper.mobile-swipe.mobile-auto-scroll .row");
  let columns = trgEl.children(); // Get all child columns
  let columnWidth = columns.outerWidth(true); // Includes margin
  let totalColumns = columns.length; // Total number of columns
  let currentIndex = 0;
  if (trgEl.length) {
    setInterval(function () {
      // Calculate the next scroll position
      currentIndex++;
      if (currentIndex >= totalColumns) {
        // Reset to the start (scroll back to the first column)
        currentIndex = 0;
        trgEl.animate({ scrollLeft: 0 }, 800); // Smoothly scroll back to the start
      } else {
        // Scroll to the next column
        trgEl.animate({ scrollLeft: currentIndex * columnWidth }, 800);
      }
    }, 3000); // Run every 3 seconds
  }
});
$(document).on(
  {
    mouseenter: function () {
      let self = $(this);
      self.addClass("active-menu");
    },
    mouseleave: function () {
      let self = $(this);
      self.removeClass("active-menu");
    },
  },
  ".menu-list-box li.menu-item"
);

$(document).on('click', '.middle-banner, .clickable, .media-banner-wrapper.with-add-cart-icon', function(e) {
  if ($(e.target).closest('.product-view-button').length) {
    return; // stop here — no redirect
  }
  let link = $(this).attr('data-href');
  if (link) {
    window.location.href = link;
  }
});